import React, { useContext } from "react";
import { Box, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import Application from "../../../components/application";
import MyPanel from "../../../components/myPanel";
import MyLabel from "../../../components/myLabel";
import MyButton from "../../../components/myButton";
import { useNavigate, useParams } from "react-router-dom";
import useVideoState from "../../../hooks/useVideoState";
import { useEffect, useState } from "react";
import MyLoading from "../../../components/myLoading";
import MyEstrelas from "../../../components/myEstrelas";
import Styles from "../videoVisto/style";
import { usePDF } from 'react-to-pdf';
import CsvDownloader from 'react-csv-downloader';
import TELAS from "../../../constants/telas";
import { AuthContext } from "../../../contexts/auth";
import TELA_ACOES from "../../../constants/telaAcoes";
import permissaoTelas from "../../../utils/permissaoTelas";

const PAGINA = {
    aplicacao: 'SisPalo - Colaborador',
    funcionalidade: 'Cursos',
    tela: TELAS.CURSOS,
    acoes: [TELA_ACOES.Consultar, TELA_ACOES.Imprimir]
}


const VideoVisto = () => {
    const navigate = useNavigate()
    const { id, idCurso } = useParams()
    const [imprimindo, setImprimindo] = useState(false)    
    const states = useVideoState()
    const { toPDF, targetRef } = usePDF({filename:  `Video_${states.nome?.value}.pdf`});    
    let styles = Styles()
    const {permissaoUsuario} = useContext(AuthContext); /* permissão para telas*/        
    

    useEffect(()=>{
        /* permissão para telas*/
        if (permissaoTelas(permissaoUsuario, TELA_ACOES.Consultar, PAGINA)){
            states.cursos.set(idCurso)
            if (id && id !== ''){
               states.listaColaboradorViu.set(id)
            }
        }
        else {
            navigate('/gestor/dashboard')
        }
    }, [])

    useEffect(()=>{
        let imprimir = async ()=>{
                await toPDF()
                setImprimindo(false)
           }

        if (imprimindo){
            imprimir()
        }
    }, [imprimindo]) 

    const handlerImprimir = async ()=>{
        setImprimindo(true)
    }

    let columns = [{id: 'name',displayName: 'Colaborador'}, 
                   {id: 'function',displayName: 'Função'}, 
                   {id: 'postcompany',displayName: 'Posto'}, 
                   {id: 'coordenador',displayName: 'Coordenador'}, 
                   {id: 'data_inicio',displayName: 'Data Início'}, 
                   {id: 'data_final',displayName: 'Data Término'}, 
                   {id: 'nota',displayName: 'Avaliação'}];
                   
    const asyncFnComputeDate = () => {
        // do whatever you need async
        return Promise.resolve(states.listaColaboradorViu?.value.map(item=>{return {name:item.cooperator.name,
                                                                                    function:item.cooperator.function,
                                                                                    postcompany:item.cooperator.postcompany?.name,
                                                                                    coordenador:item.cooperator.postcompany?.user_id,
                                                                                    data_inicio:item.data_inicio,
                                                                                    data_final:item.data_final,
                                                                                    nota:item.nota,
                                                                                    }})
        );
    };   
    return (
  
        <Application>
            <MyPanel>
                <MyLoading render={states.submit.value || imprimindo}/>
                <Stack spacing={2} ref={targetRef} sx={{padding:'0 10px'}}>
                    <Box sx={{display:'flex', justifyContent:'space-between'}}>
                            <Box>
                                    <MyLabel sx={styles.title} component='h1' text={`Lista de visualização.`}/>
                                    <MyLabel sx={styles.subtitle} component='h2' text={`Curso: ${states.nomeCurso.value}`}/>
                                    <MyLabel sx={styles.subtitle} component='h2' text={`Video: ${states.nome.value}`}/>
                            </Box>
                                {
                                    imprimindo ? <></> :
                                    <Box >
                                        <Box sx={{display:'flex', justifyContent:'end'}}>
                                            <CsvDownloader filename= {`video_${states.nome.value}`}
                                                extension=".csv"
                                                separator=";"
                                                wrapColumnChar=""
                                                columns={columns}
                                                datas={asyncFnComputeDate}
                                            >
                                                <MyButton disabled={!permissaoTelas(permissaoUsuario, TELA_ACOES.Imprimir, PAGINA)} color='primary'variant='contained' text='Planilha' sx={{marginRight:'10px'}}/>
                                            </CsvDownloader>                                        
                                            <MyButton disabled={!permissaoTelas(permissaoUsuario, TELA_ACOES.Imprimir, PAGINA)} color='primary' onClick={handlerImprimir} variant='contained' text='Imprimir' sx={{marginRight:'10px'}}/>
                                            <MyButton color='warning' onClick={()=>navigate(`/gestor/curso/${states.cursos.value}/videos`)} variant='contained' text='Voltar'/>
                                        </Box>
                                    </Box>
                                }

                        </Box>

                    <Box sx={{minHeight:'200px'}}>
                        <TableContainer component={Paper} >
                            <Table size="small" aria-label="simple table">
                                <TableHead >
                                        <TableRow >
                                            <TableCell sx={styles.tableHead}>Colaborador</TableCell>
                                            <TableCell sx={styles.tableHead}>Função</TableCell>
                                            <TableCell sx={styles.tableHead}>Posto</TableCell>
                                            <TableCell sx={styles.tableHead}>Coordenador</TableCell>                                            
                                            <TableCell sx={styles.tableHead}>Data Início </TableCell>
                                            <TableCell sx={styles.tableHead}>Data Término</TableCell>
                                            <TableCell sx={styles.tableHead}>Avaliação </TableCell>
                                        </TableRow>
                                </TableHead>
                                <TableBody>
                                        {
                                            states.listaColaboradorViu.value?.map((item, key)=>{
                                                return (
                                                    <TableRow key={key} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                        <TableCell component="th" scope="row" >{item.cooperator.name} </TableCell>
                                                        <TableCell component="th" scope="row" >{item.cooperator.function} </TableCell>
                                                        <TableCell component="th" scope="row" >{item.cooperator.postcompany?.name} </TableCell>
                                                        <TableCell component="th" scope="row" >{item.cooperator.postcompany?.user_id}</TableCell>
                                                        <TableCell component="th" scope="row" >{item.data_inicio} </TableCell>
                                                        <TableCell component="th" scope="row" >{item.data_final} </TableCell>                                                            
                                                        <TableCell component="th" scope="row" sx={{width:'155px'}}>
                                                                <MyEstrelas titulo={item.nota} nota={item.nota} />
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            })
                                        }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Stack>
            </MyPanel>
        </Application>
    )
}

export default VideoVisto;